/**
 * Substring filter for Select options. Normalizes both sides:
 *   - NFD-decomposes Unicode, strips combining marks (accent folding)
 *   - Folds the three dash-like glyphs (+, −, -) used in our timezone labels
 *     so users can type "utc4" and hit "UTC+4" / "UTC−4" / "UTC-4"
 *   - Case-insensitive
 *
 * Whitespace is preserved — "new yor" should match "New York" but "newyor"
 * shouldn't, otherwise word boundaries become meaningless.
 *
 * Empty query always matches.
 */
export function matchesSearch(label: string, query: string): boolean {
  if (query === '') return true;
  return normalize(label).includes(normalize(query));
}

function normalize(s: string): string {
  return s
    .normalize('NFD')
    // Combining diacritical marks block (U+0300–U+036F)
    .replace(/[̀-ͯ]/g, '')
    // Plus / hyphen-minus / en-dash / em-dash / minus-sign all collapse to empty
    // so "utc+4" / "utc−4" / "utc-4" / "utc4" all hit the same target
    .replace(/[+\-−–—]/g, '')
    .toLowerCase();
}
